import React from "react";
import { Loader2 } from "lucide-react";

const sizeMap = { small: 20, medium: 28, large: 40 };

const LoadingSpinner = ({ size = "medium", message = "Loading...", fullHeight = false }) => (
  <div
    role="status"
    className="flex w-full flex-col items-center justify-center gap-3 p-10"
    style={{ height: fullHeight ? "100%" : "auto", minHeight: fullHeight ? 300 : "auto" }}
  >
    <Loader2 className="animate-spin text-primary" size={sizeMap[size] || sizeMap.medium} />
    {message && <p className="text-sm font-medium text-muted-foreground">{message}</p>}
  </div>
);

export default LoadingSpinner;
